import React from "react";
import { Group, ThemeIcon, Stack, Text, ActionIcon } from "@mantine/core";
import {
  IconCircleDashedCheck,
  IconPlayerStop,
  IconInfoCircle,
} from "@tabler/icons-react";

interface NodeStatusProps {
  status: "running" | "stopped" | "starting_up";
}

const NodeStatus: React.FC<NodeStatusProps> = ({ status }) => {
  const statusDetails = {
    running: {
      color: "blue",
      text: "RUNNING",

      icon: <IconCircleDashedCheck size={24} />,
    },
    stopped: {
      color: "red",
      text: "STOPPED",

      icon: <IconPlayerStop size={24} />,
    },
    starting_up: {
      color: "green",
      text: "STARTING UP",
      statusDetail: "Node is initializing. This may take a few moments.",
      icon: <IconCircleDashedCheck size={24} />, // Placeholder icon for consistency
    },
  };

  const { color, text, icon } = statusDetails[status];

  return (
    <Group pr="sm" justify="center" gap="xs" mb="10px">
      {/* Stack texts vertically */}
      <Stack gap="xs">
        <Text
          size="sm"
          style={{
            fontWeight: 700,
          }}
        >
          {text}
        </Text>
        <Text size="xs" mt="-2rem" color="dimmed">
          status
        </Text>
      </Stack>

      {/* Icon on the right */}
      <ThemeIcon
        color={color}
        size="md"
        variant="filled"
        aria-label="Status icon"
      >
        {icon}
      </ThemeIcon>

      {/* Info ActionIcon */}
    </Group>
  );
};

export default NodeStatus;
